export interface BreachPathDetailsWebComponentSchema {
  // all the data needed for rendering
  data: any;
  externalFilters: Array<any>;
}

export type BreachPathNode = {
  _id: string;
  name: string;
  companyId: string;
  issueId: string;
  uid: number;
  type: number;
  uniqueIdentifier: string;
  metadata: string;
  risk: string;
  createdAt: string;
  updatedAt: string;
};

export type BreachPathNodeDefaultMetadata = {
  cloud_account: string;
  provider: string;
  operating_system: number;
  region: string;
  resource_id: string;
  resource_type: string;
}

export type BreachPathNodeMetadata =
  BreachPathVPCInternetGatewayNode
  | BreachPathEC2NetworkACLNode
  | BreachPathNetworkSecurityGroupsNode
  | BreachPathEC2InstanceNode;

export type BreachPathPath = {
  source: BreachPathNode;
  target: BreachPathNode;
};

export type BreachPathVPCInternetGatewayNode = {
  uniqueIdentifierCloud: string;
  resourceId: string;
  region: string;
  operatingSystem: number;
  cloudAccount: string;
  vpcId: string;
};

export type BreachPathEC2NetworkACLNode = {
  uniqueIdentifierCloud: string;
  resourceId: string;
  region: string;
  operatingSystem: number;
  cloudAccount: string;
  subnetsIds: string[];
  aclEntries: Record<string, any>[];
};

export type BreachPathNetworkSecurityGroupsNode = {
  uniqueIdentifierCloud: string;
  resourceId: string;
  region: string;
  operatingSystem: string;
  cloudAccount: string;
  ingressRules: Record<string, any>[];
  egressRules: Record<string, any>[];
};

export type BreachPathEC2InstanceNode = {
  uniqueIdentifierCloud: string;
  resourceId: string;
  region: string;
  operatingSystem: string;
  cloudAccount: string;
  imageId: string;
  vpcId: string;
  subnetId: string;
  securityGroups: Record<string, any>[];
};

export type BreachPathNodeRisk = {
  information?: {
    score_breakdown: {
      baseScore: number;
      internalMultiplier: {
        activeMisconfigurationsCount: number;
        misconfigurationsScore: number;
        activeApplicationsCount: number;
        applicationsScore: number;
        activeUsersCount: number;
        usersScore: number;
      };
      multiplier: {
        applications: number;
        users: number;
      };
      finalScoreFloat: number;
      finalScore: number;
    };
    cve_count: number;
    misconfiguration_ids: number[];
    cve_ids: string[];
  };
  error?: {
    message: string;
    code: number;
  };
} | null;

export type CveData = {
  standardId: string;
  riskScore: {
    displayMetric: string;
    value: number;
  };
  hasExploit: boolean;
  summary: string;
}

export enum ColumnKeys {
  RESOURCE_NAME = 'resourceName',
  RESOURCE_ID = 'resourceId',
  RESOURCE_TYPE = 'resourceType',
  PLATFORM = 'platform',
}

export enum Column {
  RESOURCE_NAME,
  RESOURCE_ID,
  RESOURCE_TYPE,
  PLATFORM,
}

export type BreachPathIssue = {
  _id: string;
  companyId: string;
  name: string;
  mainResource: {
    resourceId: string;
    resourceName: string;
    resourceType: number;
  };
  affectedResources: {
    resourceId: string;
    resourceName: string;
    resourceType: number;
  }[];
  scoreBreakdown: {
    baseScore: number;
    multiplier: {
      endpoints: number;
      applications: number;
      users: number;
    };
    finalScore: number;
  };
  cveCount: number;
  operatingSystem: number;
  cloudAccount: string;
  region: string;
  createdAt: string;
  updatedAt: string;
};
